import { render, staticRenderFns } from "./ContentCard.vue?vue&type=template&id=2e6b09ca&"
import script from "./ContentCard.vue?vue&type=script&lang=ts&"
export * from "./ContentCard.vue?vue&type=script&lang=ts&"
import style0 from "./ContentCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports